export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations d'enregistrement"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmé"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Public"])}
}